import {
  DATE_PRESETS,
  DatePresets,
  toDate,
  toReadableDateString,
} from '../../helper';

export interface DateDisplayProps {
  date?: string | Date | null;
  locale?: string;
  options?: Intl.DateTimeFormatOptions;
  preset?: DatePresets;
}

export const DateDisplay = ({
  date,
  locale,
  options,
  preset = 'MEDIUM',
}: DateDisplayProps) => {
  const dateInstance = toDate(date);
  const effectiveOptions = options ?? DATE_PRESETS[preset];
  const display = toReadableDateString(dateInstance, locale, effectiveOptions);
  return <span>{display}</span>;
};
